import React, { useState, useEffect } from 'react';

// Ім'я поля з помилки може бути шляхом усередині підформи (parent---index---name),
// тому додатково порівнюємо з його останнім сегментом
const matchesName = (field, fieldName) =>
    field.name === fieldName || field.name === fieldName.split('---').pop();

// Поле може лежати в групі всередині вкладки, тому шукаємо його рекурсивно
const containsField = (fields, fieldName) => (fields ?? []).some(field =>
    matchesName(field, fieldName) ||
    containsField(field.fields, fieldName) ||
    (field.tabs ?? []).some(tab => containsField(tab.fields, fieldName))
);

// Вкладки з полями: renderFields малює поля активної вкладки засобами форми, що містить групу
const TabsGroup = (props) => {
    const [activeIndex, setActiveIndex] = useState(0);

    const tabs = props.tabs ?? [];
    const activeTab = tabs[activeIndex];

    // Якщо перевірка форми знайшла помилку в полі з іншої вкладки — відкриваємо ту вкладку.
    // formError — новий об'єкт на кожну невдалу перевірку, тому ефект спрацьовує щоразу,
    // а на щойно змонтованій групі відкриває потрібну вкладку одразу.
    useEffect(() => {
        const fieldName = props.formError?.fieldName;
        if (!fieldName) return;
        const errorTabIndex = tabs.findIndex(tab => containsField(tab.fields, fieldName));
        if (errorTabIndex >= 0) setActiveIndex(errorTabIndex);
    }, [props.formError]);

    return (<div className={'tabs-group' + (props.className ? ` ${props.className}` : '')}>
        <div className="tabs-group-tabs">
            {tabs.map((tab, index) =>
                <button type="button" key={index} className={'tabs-group-tab' + (index === activeIndex ? ' active' : '')}
                    onClick={() => setActiveIndex(index)}>
                    {tab.label}
                </button>
            )}
        </div>
        {activeTab?.description && <div className="tabs-group-description" dangerouslySetInnerHTML={{ __html: activeTab.description }} />}
        {props.renderFields(activeTab?.fields ?? [])}
    </div>);
}

export default TabsGroup;
